import { LicensePlateState } from "@redotech/redo-return-ui/flows/return-flow/license-plate";
import { StepTypeDetailsProps } from "@redotech/redo-return-ui/flows/step";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const LicensePlateDetails = memo(function LicensePlateDetails({
  stepSelect,
  state,
  setState,
}: StepTypeDetailsProps<LicensePlateState>) {
  return (
    <Flex dir="column" gap="md">
      <Flex dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          Scope
        </Text>
        <Text fontSize="xs" fontWeight="regular" textColor="tertiary">
          {state.scope === "return_item"
            ? "Per-item — each unit gets its own license plate sticker."
            : "Per-return — one license plate for the whole package."}
        </Text>
      </Flex>
      <Flex dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          Next step (optional)
        </Text>
        {stepSelect({
          value: state.next,
          valueChange: (next) => setState((state) => ({ ...state, next })),
          handleIndex: 0,
        })}
        <Text fontSize="xxs" fontWeight="regular" textColor="tertiary">
          Leave empty to make this a terminal step.
        </Text>
      </Flex>
      <Text fontSize="xs" fontWeight="regular" mt="lg">
        Generates a license plate sticker that the warehouse worker attaches to
        the unit so it can be tracked through the rest of the processing flow.
      </Text>
    </Flex>
  );
});
